import makeStyles from '@material-ui/core/styles/makeStyles';


export default makeStyles({
  faixasComissoes__divider: {
    borderColor: '#FEFEFEAA',
    marginTop: '5px !important',
  },
});
